import { sendGa4Event } from './analytics';

export const AnalyticsEvent = {
  SIGNUP: 'signup',
  LOGIN: 'login',
  CHECKOUT_START: 'checkout_start',
  CHECKOUT_SUCCESS: 'checkout_success',
  CHECKOUT_CANCEL: 'checkout_cancel',
  DOWNLOAD: 'download',
  BLOG_VIEW: 'blog_view',
  PROMOTION_BANNER_VIEW: 'promotion_banner_view',
  PROMOTION_CODE_COPY: 'promotion_code_copy',
  PROMOTION_LEARN_MORE: 'promotion_learn_more',
  PROMOTION_DISMISS: 'promotion_dismiss',
  PROMOTION_FOOTER_REOPEN: 'promotion_footer_reopen',
  GUEST_CHECKOUT_START: 'guest_checkout_start',
  BUNDLE_VIEW: 'bundle_view',
  OAUTH_LOGIN: 'oauth_login',
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent];

export default function trackEvent(
  eventName: AnalyticsEventName,
  props?: Record<string, string | number | boolean>,
): void {
  if (window.plausible) {
    window.plausible(eventName, { props });
  }

  sendGa4Event(eventName, props);
}
